import { jsx } from 'react/jsx-runtime';

/** ![arrowUpIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJtNSAxMiA3LTcgNyA3TTEyIDE5VjUiLz48L3N2Zz4=) */
const arrowUpIcon = /*#__PURE__*/jsx("path", {
  d: "m5 12 7-7 7 7M12 19V5"
});

export { arrowUpIcon };
